import React from "react";
import "./AboutUsIntro.css";
import { Stack } from "react-bootstrap";
import { map } from "lodash";
import {Image} from "react-bootstrap";
export const AboutUsIntro = ({ data }) => {

const cardData = [
    {
        title: 'Direct Hotel & Supplier Partnerships  '
    },
    {
        title: 'Curated Local Experiences That Add Value  '
    },
    {
        title: 'End-to-End Event & Travel Execution  '
    },
    {
        title: 'Updated Market Knowledge & Pricing Insight   '
    },
    
    {
        title: 'A Reliable Extension of Your Team  '
    },
    {
        title: 'End-to-End Logistics & Vendor Coordination '
    },
]

    return (
        <>
            <div className="AboutUsIntro standard-padding">
                <Stack>
                    <h1 className="heading mb-4 aboutintroheading">{data.head}</h1>
                    {map(data.text, (text, index) => (
                        <p key={index} className="AboutUsIntro-text text">{text}</p>
                    ))}
                </Stack>
                <Stack className="AboutUsIntro-items-mobile-container">

                    {
                        cardData.map((e)=>(
                            <div className="AboutUsIntro-items-mobile" >
                            <Image className="AboutUsIntro-items-image" alt="img" src="/assets/icon.png" />
                            <p className="AboutUsIntro-items-text"> {e.title}</p>
                            {/* <p className="items-text2">You will get a great experience across the globe and it depicts that DMC has a wide understanding of travel.</p> */}
                        </div>
                        ))
                    }
                       
                    </Stack>
            </div>
        </>
    )
}